import { ICmsBlock, NICmsBlock } from '@icms/core/resource/block/icms-block';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace NMultisiteGeolocationModal {
    /**
     * Component id and block url
     */
    export const componentId = 'multisite-geolocation';

    /**
     * Multiste modal bLock
     */
    export type Block = ICmsBlock<IBlockData>;

    /**
     * Multiste modal bLock data
     */
    export type IBlockData = NICmsBlock.IData<unknown>;

    /**
     * Modal block content
     */
    export interface IBlockDataContent {
        cmsCountryCode?: string;
        variants: IBlockContentVariant[];
    }

    export interface IBlockContentVariant {
        /**
         *  Comma separated contry codes
         */
        countries: string;
        /**
         *  Default selected country id
         */
        defaultSiteId: string;
        /**
         * Top Heading
         */
        title: string;
        /**
         * First subtitle
         */
        subtitle1?: string;
        /**
         * Second subtitle
         */
        subtitle2?: string;
        /**
         * Confirmation button copy
         */
        confirmButtonCopy?: string;
        /**
         * Close button copy
         */
        closeButtonCopy?: string;
        image?: string;
    }

    /**
     * Initiatod data passed to modal
     */
    export interface IInitiatorData {
        matchingCountry: string; // customer geo if matched
    }
}
